import { CorsComponent, CorsRouter } from '@weapp/ui';
import { classnames, moduleRouter } from '@weapp/utils';
import React from 'react';
import { pageViewClsPrefix } from '../../../constants';
import ebdcoms from '../../../utils/ebdcoms';
import { OtherProps } from '../../types';
import { getModalConfigParams } from '../../utils';
import {
  isLastDialog, pushDialog, refreshEbComs, removeDialog,
} from '../utils';
import {
  CrmCustomPages,
  fomatParentPath,
  getApp,
  getCompName,
  getCorsProps,
  getModuleProjName,
  isComposePage,
  isSupportedSysPage,
  SignPages,
  suffix,
} from './Dialog';
import { getCrmCustomModule, getLinkInfo } from './utils';

const { SystemPageType, PageType } = ebdcoms.get();
const { Combinate } = PageType;
const {
  ContactDetail,
  ApprovalDetail,
  ApprovalNoDisturb,
  ApprovalBatchOperation,
  NewDocument,
  SubmitApplication,
  MeetingRoomInfo,
  CareDetail,
} = SystemPageType;

interface SingComProps {
  link: string;
  parentPath: string;
  SingleComProps: any;
}

interface SingComState {
  visible: boolean;
  parentPath: string;
  careVisible: boolean;
}

export default class SingCom extends React.PureComponent<SingComProps, SingComState> {
  constructor(props: SingComProps) {
    super(props);
    pushDialog(this);
  }

  state = {
    visible: true,
    parentPath: this.props.parentPath,
    careVisible: false,
  };

  modalName: string = '';

  setVisible = (visible: boolean, async?: boolean) => {
    this.setState({ visible });
    if (visible) {
      pushDialog(this);
      this.checkCareDetail();
    } else {
      removeDialog(this, async);
    }
  };

  onClose = (isEventEmitter?: boolean, isAll?: boolean) => {
    const onlyLast = !isAll && isEventEmitter;
    if (onlyLast && !isLastDialog(this)) {
      return;
    }

    this.setVisible(false, onlyLast);
  };

  updateParentPath = () => {
    const parentPath = fomatParentPath(this.props.SingleComProps);
    this.setState({ parentPath });
  };

  openCareDetail = () => {
    const { link } = this.props;
    const [, urlParams] = getLinkInfo(link);
    const { module = '', id: paramId = '-1' } = urlParams;
    if (!this.state.careVisible) {
      this.setState({ careVisible: true });
      const { history, location, match } = this.props.SingleComProps;
      // 打开弹框（携带参数）
      moduleRouter.open(
        {
          ...this.props,
          history,
          location,
          match,
        } as any,
        getModuleProjName(module),
        paramId,
        {
          rootPath: window.location.pathname,
        },
      );
    }
  };

  componentDidMount() {
    window.addEventListener(
      'popstate',
      () => {
        this.setState({ careVisible: false });
      },
      false,
    );

    this.checkCareDetail();
  }

  // 关注事项详情 需要更新主地址、通过公共组件方法调用弹窗
  checkCareDetail = () => {
    const { getAtob } = ebdcoms.get();
    const baseStr = this.getBaseStr();
    const { id } = getAtob(baseStr || '');
    if (id === CareDetail) {
      this.updateParentPath();
      this.openCareDetail();
    }
  };

  // 组件卸载时清除事件监听
  componentWillUnmount() {
    window.removeEventListener('popstate', () => {}, false);
  }

  getModalConfig = () => {
    const { getAtob, OpenMode } = ebdcoms.get();
    const baseStr = this.getBaseStr();
    const {
      isBlankClose, modalWidth, modalHeight, mode,
    } = getAtob(baseStr);
    const placement = mode === OpenMode.SlideLeftFromRight ? 'right' : 'middle';

    return getModalConfigParams({
      isBlankClose,
      modalWidth,
      modalHeight,
      placement,
      dialogInstance: this,
    });
  };

  getBaseStr = () => {
    const { link } = this.props;
    const [linkPath] = getLinkInfo(link);
    const [, firstDlg, secondDlg] = linkPath.split(suffix);
    let baseStr = firstDlg;

    if (secondDlg) {
      [baseStr] = secondDlg.split('/');
    }
    return baseStr;
  };

  /**
   * 模块弹窗组件内保存后的回调
   *  一般只要对数据进行了修改，都需要触发此回调更新组件（目前只支持业务列表组件）
   */
  onSaveCallBack = () => {
    refreshEbComs();
  };

  onSave = (type: string) => {
    if (type === 'read') return; // 文档打开详情，如果是read就不触发刷新
    if (type === 'crm') {
      this.setVisible(false);
    }
    refreshEbComs();
  };

  renderComponent = () => {
    const { link } = this.props;
    const [linkPath, urlParams] = getLinkInfo(link);
    const baseStr = this.getBaseStr();

    const { getAtob, OpenMode } = ebdcoms.get();
    const {
      mode, id, winSize, appId, isBlankClose,
    } = getAtob(baseStr);
    const placement = mode === OpenMode.SlideLeftFromRight ? 'right' : 'middle';
    const isOpenMiddle = placement === 'middle';

    if (isComposePage(linkPath)) {
      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_e7jdbs`}
          app={getApp(Combinate)}
          compName={getCompName(Combinate, placement)}
          appId={appId}
          pageId={id}
          terminalType="PC"
          comParams={urlParams}
          dialogProps={{
            placement,
            visible: this.state.visible,
            closable: true,
            ...getCorsProps(Combinate, placement, urlParams, winSize, isBlankClose, this.onClose),
            ...this.getModalConfig(),
            ...urlParams,
          }}
          onSaveCallBack={this.onSaveCallBack}
        />
      );
    }

    // 全部审批 | 指定审批表 | 审批详情
    const isApprovalDetail = id === ApprovalDetail;
    const isSubmitApplication = id === SubmitApplication;
    const isApprovalNoDisturb = id === ApprovalNoDisturb;
    const isApprovalBatchOperation = id === ApprovalBatchOperation;

    // 会议室使用情况
    const isRoomUsage = id === MeetingRoomInfo;

    const isContactDetail = id === ContactDetail;
    this.modalName = id;

    if (
      isSubmitApplication
      || isApprovalDetail
      || isApprovalNoDisturb
      || isApprovalBatchOperation
    ) {
      const {
        id: urlParamId, authType, analyseReportId, batchType, batchName,
      } = urlParams;
      const fixedParams = authType
        ? {
          authType: Number(authType),
          ...(analyseReportId ? { analyseReportId } : {}),
        }
        : {};

      // 未选择指定审批表 则为全部审批
      const isAllApprove = urlParamId === 'all' || !urlParamId;
      let compName;
      let otherProps = {};

      if (isApprovalNoDisturb) {
        compName = 'WfCLDisturbDialog';
      } else if (isApprovalBatchOperation) {
        compName = 'WfCLBatchOptDialog';
        otherProps = {
          batchOptVisable: this.state.visible,
          batchType,
          batchName,
          onBatchOptClose: this.onClose,
          dialogProps: {
            placement,
            mask: isOpenMiddle,
            visible: this.state.visible,
            ...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose),
            ...this.getModalConfig(),
          },
        };
      } else if (isAllApprove) {
        compName = 'WfCLNewFlowVisibleDialog';
        otherProps = {
          wfpRouteParam: urlParams,
        };
      } else {
        compName = 'FlowPage';
        otherProps = {
          wfCompName: isApprovalDetail ? 'ViewDialog' : 'CreateDialog',
          workflowId: urlParamId,
          requestId: urlParamId,
        } as OtherProps;
      }

      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_ifqqn8`}
          app="@weapp/workflow"
          compName={compName}
          placement={placement}
          visible={this.state.visible}
          onSaveCallBack={this.onSaveCallBack}
          onClose={this.onClose}
          // reloadEvent={this.onSave}
          dialogProps={{
            placement,
            visible: this.state.visible,
            ...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose),
            ...this.getModalConfig(),
          }}
          customParams={{
            ...urlParams,
            ...fixedParams,
            ...window.ebdcomsSubTableParams /** 子表新建的时候传过来，处理兼职人员无权限导致代码报错 */,
          }}
          {...otherProps}
        />
      );
    }

    // 无数据id时给默认值, 使弹窗能正常打开
    if (!urlParams?.id) {
      urlParams.id = '-1';

      if (id === NewDocument) {
        urlParams.id = '';
      }
    }

    if (isRoomUsage) {
      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_ifqqn8`}
          app={getApp(id)}
          compName={getCompName(id, placement)}
          onSaveCallBack={this.onSaveCallBack}
          dialogPorps={{
            placement,
            visible: this.state.visible,
            ...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose),
            ...this.getModalConfig(),
            ...urlParams,
          }}
        />
      );
    }

    if (isContactDetail) {
      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_ifqqn8`}
          app={getApp(id)}
          compName={getCompName(id, placement)}
          placement={placement}
          visible={this.state.visible}
          onSaveCallBack={this.onSaveCallBack}
          onClose={this.onClose}
          reloadEvent={this.onSave}
          mask={isOpenMiddle}
          resize={!isOpenMiddle}
          maxResizeWidth={1400}
          {...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose)}
          {...this.getModalConfig()}
          {...urlParams}
        />
      );
    }

    if (CrmCustomPages.includes(id)) {
      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_ifqqn8`}
          props={this.props.SingleComProps}
          app={getApp(id)}
          compName={getCompName(id, placement)}
          module={getCrmCustomModule(id)}
          placement={placement}
          visible={this.state.visible}
          onSaveCallBack={this.onSaveCallBack}
          onClose={this.onClose}
          mask={isOpenMiddle}
          resize={!isOpenMiddle}
          maxResizeWidth={1400}
          className={classnames({
            [`${pageViewClsPrefix}-route-dlg-right`]: !isOpenMiddle,
          })}
          top={0}
          {...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose)}
          {...this.getModalConfig()}
          {...urlParams}
        />
      );
    }

    if (SignPages.includes(id)) {
      return (
        <CorsComponent
          weId={`${this.props.weId || ''}_ifqqn8`}
          props={this.props.SingleComProps}
          app={getApp(id, { ...urlParams })}
          compName={getCompName(id, placement, { ...urlParams })}
          placement={placement}
          visible={this.state.visible}
          onClose={this.onClose}
          onSaveCallBack={this.onSaveCallBack} // 文档、crm保存回调
          closeTabDialog={this.onSave} // 业务表单保存回调
          mask={isOpenMiddle}
          resize={!isOpenMiddle}
          maxResizeWidth={1400}
          className={classnames(
            {
              [`${pageViewClsPrefix}-route-dlg-right`]: !isOpenMiddle,
            },
            `${pageViewClsPrefix}-dlg-wrap`,
          )}
          {...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose)}
          {...urlParams}
          dialogProps={{
            ...(getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose) as any)
              ?.dialogProps,
            ...this.getModalConfig(),
          }}
        />
      );
    }

    return (
      <CorsComponent
        weId={`${this.props.weId || ''}_ifqqn8`}
        props={this.props.SingleComProps}
        app={getApp(id, { ...urlParams })}
        compName={getCompName(id, placement, { ...urlParams })}
        placement={placement}
        visible={this.state.visible}
        onClose={this.onClose}
        onSaveCallBack={this.onSaveCallBack} // 文档、crm保存回调
        onSave={this.onSaveCallBack} // 我的协作保存回调
        closeTabDialog={this.onSave} // 业务表单保存回调
        mask={isOpenMiddle}
        resize={!isOpenMiddle}
        maxResizeWidth={1400}
        className={classnames(
          {
            [`${pageViewClsPrefix}-route-dlg-right`]: !isOpenMiddle,
          },
          `${pageViewClsPrefix}-dlg-wrap`,
        )}
        {...getCorsProps(id, placement, urlParams, winSize, isBlankClose, this.onClose)}
        {...this.getModalConfig()}
        {...urlParams}
      />
    );
  };

  render() {
    const { visible, parentPath } = this.state;
    const [linkPath] = getLinkInfo(this.props.link);

    if (!visible || !linkPath) return null;

    const { getAtob } = ebdcoms.get();
    const baseStr = this.getBaseStr();

    const { id } = getAtob(baseStr || '');

    if ((id && isSupportedSysPage(id)) || isComposePage(linkPath)) {
      return this.renderComponent();
    }

    return <CorsRouter weId={`${this.props.weId || ''}_vf4ee5`} rootPath={parentPath} />;
  }
}
